import React from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import Styled from 'styled';

import CommentHeaderView, { CommentHeaderViewModel } from './comment-header/comment-header-view';
import CommentContentView, { CommentContentViewModel } from './comment-content-view';
import CommentFooterView, { CommentFooterViewModel } from './comment-footer/comment-footer-view';
import defaultStyles from './comment-body-view.scss';

export class CommentBodyViewModel {
    comment: Comment;

    commentHeaderView: CommentHeaderViewModel;
    commentContentViewModel: CommentContentViewModel;
    commentFooterViewModel: CommentFooterViewModel;

    constructor(options) {
        const { comment, userMentionable, mailStore, urlBuilder, userStore, categoryStore } = options;

        this.comment = comment;

        this.commentHeaderViewModel = new CommentHeaderViewModel({
            comment,
        });

        this.commentContentViewModel = new CommentContentViewModel({
            comment,
        });

        this.commentFooterViewModel = new CommentFooterViewModel({
            comment,
            userMentionable,
            userStore,
            categoryStore,
        });
    }
}

@Styled(defaultStyles)
@observer
class CommentBodyView extends React.Component {
    render() {
        const { commentBodyViewModel, styles, customFooter, customHeader, ...rest } = this.props;

        const { commentFooterViewModel, commentContentViewModel, commentHeaderViewModel } = commentBodyViewModel;

        const { isFirstMessage } = rest;

        return (
            <div className={classnames(styles.commentBody, { [styles.isFirstMessage]: isFirstMessage })}>
                <div className={styles.comment}>
                    {customHeader !== undefined ? (
                        customHeader
                    ) : (
                        <CommentHeaderView commentHeaderViewModel={commentHeaderViewModel} />
                    )}
                    <CommentContentView commentContentViewModel={commentContentViewModel} />
                    <div className={styles.commentWrapper} />
                </div>
                {customFooter !== undefined ? (
                    customFooter
                ) : (
                    <div className={classnames(styles.footer, { [styles.isFirstFooter]: isFirstMessage })}>
                        <CommentFooterView commentFooterViewModel={commentFooterViewModel} {...rest} />
                    </div>
                )}
            </div>
        );
    }
}

export default CommentBodyView;
